// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-so-modal-input-wrapper-with-placeholder .MuiInputLabel-outlined{transform:translate(12px, 16px) scale(1)}.mobile-so-modal-input-wrapper-with-placeholder .MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(0px, 4px) scale(0.75)}\n", ""]);
// Exports
module.exports = exports;
